var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: _vm.$selectByLang("400px", "460px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("80px", "140px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.FileType") }
            },
            [
              _c("cargo-advance-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  no: "1",
                  filterable: "",
                  "select-type":
                    _vm.selectTypeNames.basic_data_TransmitFileType,
                  "default-value": _vm.oneFormData.fileType,
                  disabled: !_vm.isLockFileType || _vm.isRemarkOnly,
                  "method-params": { lob: _vm.job.lob },
                  "callback-params": { key: "fileType" }
                },
                on: { parentCallBack: _vm.setFileTypeSelectValue }
              })
            ],
            1
          ),
          _vm.bgdHp
            ? _c(
                "el-form-item",
                { staticClass: "custom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "padding-left": "30px",
                        "text-decoration": "underline",
                        border: "0"
                      },
                      attrs: { no: "2" },
                      on: { click: _vm.ylQueryClick }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          this.$t(
                            "SeaExport.CheckPreRecordedCustomsDeclaration"
                          )
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "padding-left": "30px",
                        "text-decoration": "underline",
                        border: "0"
                      },
                      attrs: { no: "3" },
                      on: { click: _vm.stateQueryClickHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          this.$t("SeaExport.CheckStatusOfCustomsDeclaration")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.backableShow
            ? _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.Back") }
                },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.cbBack,
                            callback: function($$v) {
                              _vm.cbBack = $$v
                            },
                            expression: "cbBack"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.cbBack
                      ? _c("div", { staticStyle: { width: "20%" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ReceivingDate")))
                          ])
                        ])
                      : _vm._e(),
                    _vm.cbBack
                      ? _c(
                          "div",
                          { staticStyle: { width: "70%" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "4",
                                type: "date",
                                clearable: false,
                                editable: false,
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.oneFormData.backDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.oneFormData, "backDate", $$v)
                                },
                                expression: "oneFormData.backDate"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TenBitCode") }
            },
            [
              _c("el-input", {
                attrs: { no: "5", disabled: _vm.isRemarkOnly, maxlength: "10" },
                on: { change: _vm.tenDigitCodeChangeHandler },
                model: {
                  value: _vm.oneFormData.tenDigitCode,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "tenDigitCode", $$v)
                  },
                  expression: "oneFormData.tenDigitCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.OperatingCompany") }
            },
            [
              _c("el-input", {
                attrs: { no: "6", disabled: _vm.isRemarkOnly },
                on: { change: _vm.queryBusinessHandler },
                model: {
                  value: _vm.oneFormData.companyCname,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "companyCname", $$v)
                  },
                  expression: "oneFormData.companyCname"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.FileNo") }
            },
            [
              _c("el-input", {
                attrs: { no: "7", disabled: _vm.isRemarkOnly },
                model: {
                  value: _vm.oneFormData.fileNo,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "fileNo", $$v)
                  },
                  expression: "oneFormData.fileNo"
                }
              })
            ],
            1
          ),
          _vm.bgdHp
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.CustomsNo") }
                  },
                  [
                    _c("el-input", {
                      attrs: { no: "8", disabled: _vm.isRemarkOnly },
                      model: {
                        value: _vm.oneFormData.customsNo,
                        callback: function($$v) {
                          _vm.$set(_vm.oneFormData, "customsNo", $$v)
                        },
                        expression: "oneFormData.customsNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.bgdHp
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.DateOfDeclaration") }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        no: "9",
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.oneFormData.declareDate,
                        callback: function($$v) {
                          _vm.$set(_vm.oneFormData, "declareDate", $$v)
                        },
                        expression: "oneFormData.declareDate"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
            },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "10",
                  disabled: _vm.isRemarkOnly,
                  "select-type": _vm.selectTypeNames.basic_data_Company,
                  "data-filter-function": _vm.customsBrokerFilter,
                  filterable: "",
                  "default-value": _vm.oneFormData.customsBroker || "",
                  "method-params": { customsBroker: true, active: true }
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.oneFormData.customsBroker = p.value
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TakeByCustomsBroker") }
            },
            [
              _c("el-checkbox", {
                attrs: { no: "11", disabled: _vm.isRemarkOnly },
                model: {
                  value: _vm.oneFormData.tax,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "tax", $$v)
                  },
                  expression: "oneFormData.tax"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsDeclarationPages") }
            },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  no: "12",
                  min: 1,
                  max: 9999,
                  precision: 0,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.oneFormData.customsPageNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsPageNumber", $$v)
                  },
                  expression: "oneFormData.customsPageNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsTransitOrNot") }
            },
            [
              _c("el-checkbox", {
                attrs: { no: "13" },
                model: {
                  value: _vm.oneFormData.customsTransfer,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsTransfer", $$v)
                  },
                  expression: "oneFormData.customsTransfer"
                }
              })
            ],
            1
          ),
          !_vm.isLockFileType
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SeaExport.CommodityInspectionOrNot") }
                },
                [
                  _c("el-checkbox", {
                    attrs: { no: "14" },
                    model: {
                      value: _vm.oneFormData.isCommodityInspection,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "isCommodityInspection", $$v)
                      },
                      expression: "oneFormData.isCommodityInspection"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.isLockFileType
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SeaExport.CustomsInspectionOrNot") }
                },
                [
                  _c("el-checkbox", {
                    attrs: { no: "15" },
                    model: {
                      value: _vm.oneFormData.isSpotInspection,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "isSpotInspection", $$v)
                      },
                      expression: "oneFormData.isSpotInspection"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TradeMethod") }
            },
            [
              _c(
                "el-select",
                {
                  attrs: { no: "16" },
                  model: {
                    value: _vm.oneFormData.tradeMode,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "tradeMode", $$v)
                    },
                    expression: "oneFormData.tradeMode"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.All"), value: 0 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.GeneralTrade"), value: 1 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.Processing"), value: 2 }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.FeedingCounterparts"),
                      value: 3
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.SamplesOfAdvertisingProducts"),
                      value: 4
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.OtherImportsFree"),
                      value: 5
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.Remarks") }
            },
            [
              _c("el-input", {
                attrs: { no: "17", type: "textarea", rows: 3 },
                model: {
                  value: _vm.oneFormData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "remark", $$v)
                  },
                  expression: "oneFormData.remark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomerName") }
            },
            [
              _c("el-input", {
                attrs: { no: "18", disabled: _vm.isRemarkOnly },
                model: {
                  value: _vm.oneFormData.receiveCompany,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "receiveCompany", $$v)
                  },
                  expression: "oneFormData.receiveCompany"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.ContactPerson") }
            },
            [
              _vm.isSe
                ? _c("cargo-advance-select", {
                    attrs: {
                      no: "19",
                      "select-type": _vm.selectTypeNames.static_data_Contact,
                      "allow-create": true,
                      filterable: "",
                      cache: false,
                      disabled: _vm.isRemarkOnly,
                      "default-value": _vm.oneFormData.receivePerson,
                      "static-options": _vm.contactList
                    },
                    on: { parentCallBack: _vm.contactChange }
                  })
                : _vm._e(),
              !_vm.isSe
                ? _c("el-input", {
                    attrs: { no: "20", disabled: _vm.isRemarkOnly },
                    model: {
                      value: _vm.oneFormData.receivePerson,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "receivePerson", $$v)
                      },
                      expression: "oneFormData.receivePerson"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: {
                label: _vm.$t("SeaExport.Tel"),
                disabled: _vm.isRemarkOnly
              }
            },
            [
              _c("el-input", {
                attrs: { no: "21", disabled: _vm.isRemarkOnly },
                model: {
                  value: _vm.oneFormData.receiveTel,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "receiveTel", $$v)
                  },
                  expression: "oneFormData.receiveTel"
                }
              })
            ],
            1
          ),
          _vm.isSe
            ? _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("SeaExport.AddressOfContact"),
                    disabled: _vm.isRemarkOnly
                  }
                },
                [
                  _c("el-input", {
                    attrs: { no: "22", disabled: _vm.isRemarkOnly },
                    model: {
                      value: _vm.oneFormData.receiveAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "receiveAddress", $$v)
                      },
                      expression: "oneFormData.receiveAddress"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomerAddress") }
            },
            [
              _c("el-input", {
                attrs: {
                  no: "23",
                  disabled: _vm.isRemarkOnly,
                  type: "textarea",
                  rows: 3
                },
                model: {
                  value: _vm.oneFormData.expressAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "expressAddress", $$v)
                  },
                  expression: "oneFormData.expressAddress"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "24", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "25" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.isCustomsStatusTitle,
            title: _vm.$t("SeaExport.StatusOfCustomsDeclaration"),
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isCustomsStatusTitle = $event
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptionsCustomsStatus,
              "column-defs": _vm.columnDefsCustomsStatus,
              "row-data": _vm.rowDataCustomsStatus
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApiFileDetail = params.api)
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "26" },
                  on: {
                    click: function($event) {
                      _vm.isCustomsStatusTitle = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }